export default "__VITE_ASSET__50973867__"